import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { SubscriptionPlanType } from '../utils/utilTypes';

type StateType = {
  paymentPlan: SubscriptionPlanType | null;
  handleSelectPlan: (plan: SubscriptionPlanType) => void;
  clearSelectedPlan: () => void;
};

export const usePaymentPlanDetailsSlice = create<StateType>()(
  devtools(
    (set) => ({
      paymentPlan: null,
      handleSelectPlan: (plan) =>
        set({ paymentPlan: plan }, false, 'handleSelectPlan'),
      clearSelectedPlan: () =>
        set({ paymentPlan: null }, false, 'clearSelectedPlan'),
    }),
    { name: 'Payment Plan Store' }
  )
);
